export const IGNORE_EVENTS: string[] = ["get_notifications"];
